
import React from "react";
import * as Hooks from "../../../../../hooks";
import { i18nManager } from "../../../../../i18n";
import { Schemes, Utils } from "../../../../../utils";
import { Elements } from "../../../../shared/Elements";
import * as ReactRouterDom from "react-router-dom";
import { ConfirmDialog } from "../../../../shared/ConfirmDialog";
import LoadingGif from "../../../assets/images/loading_circle.gif";
import { BoolHelper, Button, ButtonManageRef, Checkbox, Classname, DateInput, DOMHelper, Dropdown, Form, FormControl, InputManageRef, NoseurObject, NumberInput, Scheme, Subscriber, TextInput, useSubscription } from "@rivtn/noseur";
import { ApiResponseData, BaseService, CountryService, ICountry, IMember, IHost, SanitizedResponse, HostRole, HostService, ITournamentEditionScoring, TournamentService, ITournamentEditionScoreSetting, TournamentScoringSystem } from "../../../../../services";
import { CreateTournamentSectionProps, CreateTournamentSection } from "../CreateTournament";

function ScoringAndTieBreaking(props: CreateTournamentSectionProps) {

    const { active, tournamentEditionState } = props;
    const [themeMode, _] = Hooks.useThemeMode();
    const tournamentService = TournamentService.getInstance();
    const scoreInputManageRef = React.useRef<InputManageRef>(null);
    const [activeScoreIndex, setActiveScoreIndex] = React.useState(0);
    const startingScoreInputManageRef = React.useRef<InputManageRef>(null);
    const submissionNameInputManageRef = React.useRef<InputManageRef>(null);
    const [tournamentEdition, setTournamentEdition] = tournamentEditionState;
    const labels = i18nManager.Labels.host.create_tournament.scoring_and_tie_breaking;
    const [tournamentScoring, setTournamentScoring] = React.useState<ITournamentEditionScoring>();
    const [scores, setScores] = React.useState<{ label: string; is_primary: boolean; score_settings: ITournamentEditionScoreSetting; }[]>(
        Object.keys(tournamentEdition.scoring ?? {})?.length
            ? Object.values(tournamentEdition.scoring ?? {}).map((scoreSettings) => ({ label: scoreSettings.name, is_primary: tournamentEdition.meta?.primary_score === scoreSettings.id, score_settings: scoreSettings }))
            : [{ label: DOMHelper.uniqueElementId(labels.score.toLowerCase() + "_"), is_primary: true, score_settings: { label: DOMHelper.uniqueElementId(labels.score + " ") } as any }]
    );

    React.useEffect(() => {
        tournamentService.queryTournamentEditionScorings(tournamentEdition.external_id!, {
            type: "TOURNAMENT_SCORE",
        }).then(({ content }: SanitizedResponse<ITournamentEditionScoring>) => {
            if (content?.length) {
                setTournamentScoring(content[0]);
                const scoreSettings = Object.values(content[0].scoring ?? {});
                if (!scoreSettings.length) {
                    scoreSettings.push({
                        id: "points",
                        name: "Points",
                        score_per_win: 1,
                        short_name: "Pts",
                        higher_is_winner: true,
                        show_on_match_pages: true,
                        submission_name: "Points",
                        allow_participant_submit_score: false,
                        score_system: TournamentScoringSystem.POINTS,
                    } as ITournamentEditionScoreSetting);
                }
                scoreInputManageRef.current?.setValue(scoreSettings?.[0].name);
                submissionNameInputManageRef.current?.setValue(scoreSettings?.[0].submission_name);
                startingScoreInputManageRef.current?.setValue("" + (scoreSettings?.[0].starting_score ?? "0"));
                setScores(scoreSettings.map((scoreSettings) => ({ label: scoreSettings.name, is_primary: content[0].extra_data?.primary_score === scoreSettings.id, score_settings: scoreSettings })));
            }
        }).catch(BaseService.reportError);
    }, []);

    return (<div className="create-tournament-f flow details" ref={props.ref}>
        {!active && (<div className="overlay" onClick={() => props.setActiveSection(CreateTournamentSection.SCORING_AND_TIE_BREAKING, undefined, true)} />)}
        <span className="title">{labels.title}</span>
        <Form className="content" scheme={Schemes.OMNEHOST} style={{ marginTop: 20, width: "100%" }}>
            <Checkbox label={labels.track_multiple_score} style={{ marginTop: 20 }} checked={scores.length > 1} onChecked={(multiple) => {
                const newScores: any[] = [];
                newScores.push({ ...scores[0], is_primary: true });
                if (multiple) {
                    newScores.push({ label: labels.score + "_2", is_primary: false, score_settings: { name: labels.score + " 2" } as any });
                } else {
                }
                setScores(newScores);
            }} />
            {scores.length > 1 && (<>
                <hr style={{ width: "auto" }} />
                <div className="multi-scorer">
                    {scores.map((score, index) => (<div className={Classname.build({ "active": (index === activeScoreIndex) })} key={DOMHelper.uniqueElementId("ohts")}
                        onClick={() => {
                            setActiveScoreIndex(index);
                            console.log("TFGDG", scores[index]);
                            scoreInputManageRef.current?.setValue(scores[index]?.label);
                            submissionNameInputManageRef.current?.setValue(scores[index]?.score_settings?.submission_name);
                            startingScoreInputManageRef.current?.setValue("" + (scores[index]?.score_settings?.starting_score ?? 0));
                        }}>
                        <i className="fa fa-times" style={{ marginRight: 10 }} onClick={() => {
                            scores.splice(scores.indexOf(score), 1);
                            setScores([...scores]);
                            if (scores.length <= 2) {

                            }
                        }} />
                        <span>{score.label}</span>
                        {((tournamentEdition.extra_data?.primary_score === score.score_settings?.id) || score.is_primary) && (<div style={{ width: 5, height: 5, backgroundColor: "#FF7171", marginLeft: 7, borderRadius: "100%" }} />)}
                    </div>))}
                    <i className="fa fa-plus link" style={{ marginLeft: 10 }} onClick={() => {
                        setScores([...scores, { label: DOMHelper.uniqueElementId(labels.score.toLowerCase() + "_"), is_primary: false, score_settings: { name: DOMHelper.uniqueElementId(labels.score + " ") } as any }]);
                    }} />
                </div>
                <hr style={{ width: "auto", marginBottom: 0 }} />
            </>)}
            <FormControl isFieldset fill label={labels.score_label} style={{ marginTop: 15 }}>
                <TextInput fill manageRef={scoreInputManageRef} defaultValue={scores[activeScoreIndex]?.label} onInputComplete={(value: string) => {
                    scores[activeScoreIndex].label = value;
                    scores[activeScoreIndex].score_settings.name = value;
                    updateScoring();
                }} />
            </FormControl>
            <FormControl isFieldset fill label={labels.starting_score} style={{ marginTop: 15 }}>
                <NumberInput fill manageRef={startingScoreInputManageRef} defaultValue={scores[activeScoreIndex]?.score_settings?.starting_score ?? 0} onInputComplete={(value: string) => {
                    scores[activeScoreIndex].score_settings.starting_score = parseInt(value);
                    updateScoring();
                }} />
            </FormControl>
            {scores.length > 1 && (<Checkbox checked={(tournamentEdition.extra_data?.primary_score === scores[activeScoreIndex]?.score_settings?.id) || scores[activeScoreIndex]?.is_primary} label={labels.this_is_primary_score} style={{ marginTop: 20 }} onChecked={(_) => {
                for (const score of scores) {
                    score.is_primary = false;
                }
                scores[activeScoreIndex].is_primary = true;
                setTournamentEdition({ ...tournamentEdition, extra_data: { ...tournamentEdition.extra_data, primary_score: scores[activeScoreIndex].score_settings.id } });
                setScores([...scores]);
            }} />)}
            <Checkbox checked={scores[activeScoreIndex]?.score_settings?.allow_participant_submit_score} label={labels.allow_participant_submit_score} onChecked={(checked) => {
                scores[activeScoreIndex].score_settings.allow_participant_submit_score = checked;
                updateScoring();
            }} />
            <Checkbox checked={scores[activeScoreIndex]?.score_settings?.higher_is_winner} label={labels.higher_value_wins} onChecked={(checked) => {
                scores[activeScoreIndex].score_settings.higher_is_winner = checked;
                updateScoring();
            }} />
            <Checkbox checked={scores[activeScoreIndex]?.score_settings?.show_on_match_pages} label={labels.show_on_match_pages} onChecked={(checked) => {
                scores[activeScoreIndex].score_settings.show_on_match_pages = checked;
                updateScoring();
            }} />
            {(scores[activeScoreIndex]?.score_settings?.allow_participant_submit_score) && (<FormControl isFieldset fill label={labels.submission_name} style={{ marginTop: 15 }}>
                <TextInput fill manageRef={submissionNameInputManageRef} defaultValue={scores[activeScoreIndex]?.score_settings?.submission_name ?? scores[activeScoreIndex]?.score_settings?.name} onInputComplete={(value: string) => {
                    scores[activeScoreIndex].score_settings.submission_name = value;
                    updateScoring();
                }} />
            </FormControl>)}
            <span style={{ fontWeight: "bold", marginTop: 30 }}>{labels.score_system}</span>
            <span style={{ marginTop: 10 }}>{labels.score_system_info.label} <a target="_blank" href={labels.score_system_info.article_link}>{labels.score_system_info.read_more}</a></span>
            <Dropdown fill forceUpdateIfSelectedIndexChanges formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.choose_scoring_system, }}
                options={labels.scoring_systems} optionTemplate={(option: any) => (<div key={option.value} style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: 500, marginBottom: 3, fontSize: 16 }}>{option.label}</span>
                    <span>{option.desc} <a target="_blank" href={option.article_link}>{labels.read_more}</a></span>
                </div>)} selectedOptionIndex={labels.scoring_systems.findIndex((f) => f.value === (scores[activeScoreIndex]?.score_settings?.score_system))}
                onSelectOption={(o) => {
                    scores[activeScoreIndex].score_settings.score_system = o.value;
                    updateScoring();
                }} />
            {(BoolHelper.equalsAny(scores[activeScoreIndex]?.score_settings?.score_system, ["POINTS"])) && (<>
                <FormControl isFieldset fill label={labels.x_per_match_win.replace("${score_system}", i18nManager.Labels.tournaments.your_tournament.matches_and_reporting.match.scoring_system_labels[scores[activeScoreIndex]?.score_settings?.score_system])} style={{ marginTop: 15 }}>
                    <NumberInput fill defaultValue={scores[activeScoreIndex]?.score_settings?.score_per_win ?? 1}
                        onInputComplete={(value: string) => {
                            scores[activeScoreIndex].score_settings.score_per_win = parseInt(value);
                            updateScoring();
                        }} />
                </FormControl>
                <FormControl isFieldset fill label={labels.x_per_match_loss.replace("${score_system}", i18nManager.Labels.tournaments.your_tournament.matches_and_reporting.match.scoring_system_labels[scores[activeScoreIndex]?.score_settings?.score_system])} style={{ marginTop: 15 }}>
                    <NumberInput fill defaultValue={scores[activeScoreIndex]?.score_settings?.score_per_loss ?? 0}
                        onInputComplete={(value: string) => {
                            scores[activeScoreIndex].score_settings.score_per_loss = parseInt(value);
                            updateScoring();
                        }} />
                </FormControl>
                {((tournamentEdition.tie_breaker ?? tournamentScoring?.tie_breaker) === "SCORE") && (<FormControl isFieldset fill label={labels.x_per_match_draw.replace("${score_system}", i18nManager.Labels.tournaments.your_tournament.matches_and_reporting.match.scoring_system_labels[scores[activeScoreIndex]?.score_settings?.score_system])} style={{ marginTop: 15 }}>
                    <NumberInput fill defaultValue={scores[activeScoreIndex]?.score_settings?.score_per_draw ?? 0}
                        onInputComplete={(value: string) => {
                            scores[activeScoreIndex].score_settings.score_per_draw = parseInt(value);
                            updateScoring();
                        }} />
                </FormControl>)}
            </>)}
            <hr style={{ width: "auto", marginTop: 30 }} />
            <span style={{ fontWeight: "bold", marginTop: 10 }}>{labels.tie_breaker}</span>
            <span style={{ marginTop: 10 }}>{labels.tie_breaker_info.label} <a target="_blank" href={labels.tie_breaker_info.article_link}>{labels.tie_breaker_info.read_more}</a></span>
            <Dropdown fill forceUpdateIfSelectedIndexChanges formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.select_tie_breaker_mechanism, }}
                options={labels.tie_breakers} optionTemplate={(option: any) => (<div key={option.value} style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: 500, marginBottom: 3, fontSize: 16 }}>{option.label}</span>
                    <span>{option.desc} <a target="_blank" href={option.article_link}>{labels.read_more}</a></span>
                </div>)} selectedOptionIndex={labels.tie_breakers.findIndex((f) => f.value === (tournamentScoring?.tie_breaker ?? tournamentEdition.tie_breaker))} onSelectOption={(o) => {
                    setTournamentEdition({ ...tournamentEdition, tie_breaker: o.value });
                    setTournamentScoring({ ...(tournamentScoring ?? {}), tie_breaker: o.value } as any);
                }} />
            {((tournamentEdition.tie_breaker ?? tournamentScoring?.tie_breaker) === "SECONDARY_SCORE_DIFFERENCE") && (<Dropdown fill forceUpdateIfSelectedIndexChanges formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.choose_initial_score_for_tie_breaking, }}
                options={scores.map((score) => ({
                    label: score.label,
                    value: score.label,
                    not_selectable: (tournamentScoring?.extra_data?.primary_score ?? tournamentEdition.meta?.primary_score) === score.label
                }))} selectedOptionIndex={scores.findIndex((s) => s.label === (tournamentScoring?.extra_data?.initial_score_for_tie_breaking ?? tournamentEdition.meta?.initial_score_for_tie_breaking))} onSelectOption={(o) => {
                    setTournamentEdition({ ...tournamentEdition, extra_data: { ...tournamentEdition.extra_data, initial_score_for_tie_breaking: o.value } });
                }} />)}
        </Form>
        <div className="controls">
            <Button textOnly scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.prev} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                props.setActiveSection(CreateTournamentSection.STAGE_AND_FORMAT, () => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
            <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.next} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                props.setActiveSection(CreateTournamentSection.FINAL, () => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
        </div>
    </div>);

    function updateScoring() {
        setScores([...scores]);
        setTournamentEdition({
            ...tournamentEdition, scoring: scores.reduce((acc, score) => {
                acc[score.score_settings.id ?? score.label.toLowerCase().replaceAll(" ", "_")] = score.score_settings;
                return acc;
            }, {} as NoseurObject<ITournamentEditionScoreSetting>)
        });
    }

}

export default ScoringAndTieBreaking;
